// All access-token writes go through this module. Subscribers own the response
// (WebSocket reconnect, replay policy), so pages only update authentication.
const listeners = new Set();

const notify = token => {
    for (const listener of Array.from(listeners)) {
        try {
            listener(token);
        } catch (_) {
            // One unavailable consumer must not prevent the other auth updates.
            if (process.env.NODE_ENV === 'development') console.warn('Auth session listener failed');
        }
    }
};

export const subscribeAuthTokenChanges = listener => {
    listeners.add(listener);
    return () => listeners.delete(listener);
};

export const setAuthToken = (token, options = {}) => {
    const normalizedToken = token || null;
    const previous = localStorage.getItem('token');
    if (Object.prototype.hasOwnProperty.call(options, 'refreshToken')) {
        if (options.refreshToken) localStorage.setItem('refreshToken', options.refreshToken);
        else localStorage.removeItem('refreshToken');
    }
    if (normalizedToken) localStorage.setItem('token', normalizedToken);
    else localStorage.removeItem('token');
    if (normalizedToken !== previous) notify(normalizedToken);
};

export const clearAuthTokens = () => setAuthToken(null, { refreshToken: null });

export const clearAuthStorage = () => {
    localStorage.clear();
    notify(null);
};

if (typeof window !== 'undefined') {
    window.addEventListener('storage', event => {
        if (event.storageArea && event.storageArea !== window.localStorage) return;
        if (event.key === 'token' || event.key === null) {
            // Read the current value rather than a potentially superseded event.
            notify(localStorage.getItem('token'));
        }
    });
}
